export const RATING_STAR_COUNT = 5;

export const RATING_STAR_PATH =
  'M12 2.5l2.97 6.02 6.65.97-4.81 4.69 1.14 6.62L12 17.77 6.05 20.8l1.14-6.62L2.38 9.49l6.65-.97L12 2.5z';

export function parseStarCount(value: string): number {
  const trimmed = value.trim();
  if (/^[1-5]$/.test(trimmed)) {
    return Number(trimmed);
  }
  return 0;
}

/** Average display rounded to 1 decimal place (e.g. 4.5, 4.0). */
export function formatRatingAverage(average: number, count: number): string {
  if (!count || !Number.isFinite(average)) {
    return '0.0';
  }
  return average.toFixed(1);
}

/** Fill fraction for star index 1..5 given an exact average (e.g. 4.5 → 1 for stars 1-4, 0.5 for star 5). */
export function starFillFraction(average: number, starIndex: number): number {
  if (!Number.isFinite(average) || starIndex < 1) {
    return 0;
  }
  const remaining = average - (starIndex - 1);
  if (remaining <= 0) {
    return 0;
  }
  if (remaining >= 1) {
    return 1;
  }
  return remaining;
}
